const vars = {
    apiBaseUrl: '/recharges',
    sitekey: '6LfBwH8sAAAAAOuDS983LMCKM47mMn0nU9oP8W0Z',
};

export default vars;